import React from 'react'

import { LinearProgress } from '@mui/material'

import { quotaProgress, quotaSeverity } from 'components/_base/QuotaUsage'

type EnrichApiUsageQuotaProps = {
  quota: number
  usage: number
}

const EnrichApiUsageQuota = ({ quota, usage }: EnrichApiUsageQuotaProps) => {
  return (
    <div className="enrich-usage-quota">
      <div className="enrich-usage-quota__label">{`${usage || 0} / ${quota}`}</div>
      <LinearProgress
        color={quotaSeverity(quota, usage || 0) ?? 'primary'}
        value={quotaProgress(quota, usage || 0)}
        variant="determinate"
      />
    </div>
  )
}

export default EnrichApiUsageQuota
